const archiveOrderby = document.querySelector('#orderby')
const archiveOrder = document.querySelector('#order')

if (archiveOrderby && archiveOrder) {
  const setOrder = () => {
    const orderBy = archiveOrderby.value

    const order = orderBy === 'title' ? 'ASC' : 'DESC'

    archiveOrder.value = order
  }

  archiveOrderby.addEventListener('change', setOrder)
}
